import React, { useState, useEffect, useRef } from "react";
import { Paper } from "@material-ui/core";
import { baseUrl } from "../../../services/config";
import { Table, Spinner } from "react-bootstrap";
// import { toAbsoluteUrl } from "../../../_metronic/_helpers";
// import SVG from "react-inlinesvg";
// import ReactToPrint from "react-to-print";
import { useAlert } from "react-alert";
// import PrintSchoolInvoice from "../SchoolManagement/PrintSchoolInvoice/PrintSchoolInvoice";

const InvoicesDuePayment = () => {
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setLoading] = useState(false);

  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const [allsessions, setallsessions] = useState([]);
  const [currentsession, setcurrentsession] = useState("");
  const [showResult, setShowResult] = useState(false);
  const alert = useAlert();
  //   const pageStyle = `
  //   @page {
  //     size: A4 portrait !important;
  //   }
  //   `;
  const [selectedChallans, setSelectedChallans] = useState([]);
  const [mainCheckBoxChecked, setMainCheckboxChecked] = useState(false);
  const searchClicked = useRef(false);
  const banksloaded = useRef(false);

  const [regionsData, setRegionsData] = useState([]);
  const [regionId, setRegionId] = useState("");
  const [schoolAccountData, setSchoolAccountData] = useState([]);
  const [schoolAccountId, setSchoolAccountId] = useState("");
  const [allInvoicesList, setAllInvoicesList] = useState([]);
  const [rawInvoices, setRawInvoices] = useState([]);
  const [isCombine, setIsCombine] = useState(false);

  const statusColorMap = {
    4: "green",
    3: "orange",
    2: "red",
    1: "black",
  };

  const statusMap = {
    4: "Paid",
    3: "In Process",
    2: "Partially Paid",
    1: "Unpaid",
  };

  useEffect(() => {
    if (!banksloaded.current) {
      banksloaded.current = true;
      getAllSessions();
      getRegions();
      getSchoolAccounts();
    }

    if (searchClicked.current) {
      searchClicked.current = false;
      // setSelectedChallans([]);
      setAllCheckboxes(true);
    } else {
      checkAllCheckBoxes();
    }
  }, [[], selectedChallans]);
  // }, []);

  const getMonthName = (date) => {
    if (date == "") {
      return "_";
    }
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}, ${d.getFullYear()}`;
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setallsessions(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setcurrentsession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getRegions = async () => {
    await fetch(`${baseUrl}/regions`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setRegionsData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
        setRegionsData([]);
      });
  };

  const changesession = (id) => {
    setcurrentsession(id);
  };

  const getSchoolAccounts = async () => {
    await fetch(`${baseUrl}/school-accounts`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          if (!data.metadata.success) {
            alert.error(data.metadata.message);
            return;
          } else {
            setSchoolAccountData(data.payload);
          }
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getInvoices = () => {
    if (currentsession == "") {
      alert.error("Please Select Session");
      return;
    }

    setLoading(true);

    const data = {
      year_id: currentsession,
      region_id: regionId,
      school_account_id: schoolAccountId,
    };

    fetch(`${baseUrl}/invoices-due-payments`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data?.payload?.length == 0) {
            setSelectedChallans([]);
            setAllInvoicesList([]);
            setRawInvoices([]);
          }
          const invoices = data.payload || [];
          setRawInvoices(invoices);
          setAllInvoicesList(
            isCombine ? combineInvoicesBySchool(invoices) : invoices,
          );

          searchClicked.current = true;
          setLoading(false);
          setShowResult(true);
        } else {
          alert.error(data.metadata.message);
          setSelectedChallans([]);
          setAllInvoicesList([]);
          setRawInvoices([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };

  const combineInvoicesBySchool = (invoices) => {
    const grouped = invoices.reduce((acc, invoice) => {
      if (invoice.payment_status === 4) return acc;

      const schoolId = invoice.school_account?.id;
      const schoolName = invoice.school_account?.school_name;
      const regionName = invoice.school_account?.region?.name;

      if (!schoolId) return acc;

      if (!acc[schoolId]) {
        acc[schoolId] = {
          school_id: schoolId,
          school_name: schoolName,
          region_name: regionName,
          invoices: [],
          total_invoices: 0,
          total_payable: 0,
          total_paid: 0,
          total_balance: 0,
        };
      }

      acc[schoolId].invoices.push(invoice);
      acc[schoolId].total_invoices += 1;
      acc[schoolId].total_payable += Number(invoice.payable || 0);
      acc[schoolId].total_paid += Number(invoice.paid || 0);
      acc[schoolId].total_balance += Number(invoice.balance || 0);

      return acc;
    }, {});
    return Object.values(grouped);
  };

  useEffect(() => {
    if (!rawInvoices.length) return;

    setAllInvoicesList(
      isCombine ? combineInvoicesBySchool(rawInvoices) : rawInvoices,
    );
    searchClicked.current = true;
  }, [isCombine, rawInvoices]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    var element = document.getElementById("hettingheight");

    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) setAllCheckboxes(false);
    else setAllCheckboxes(true);
  };

  const setAllCheckboxes = (value) => {
    setMainCheckboxChecked(value);
    if (value) {
      setSelectedChallans([]);
    }

    allInvoicesList.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedChallan(item);
      } else {
        AddSelectedChallan(item);
      }
    });
  };

  const checkAllCheckBoxes = () => {
    if (allInvoicesList.length == selectedChallans.length) {
      setMainCheckboxChecked(true);
    } else if (mainCheckBoxChecked) {
      setMainCheckboxChecked(false);
    }
  };

  const handleChallansCheckBoxClick = (key) => {
    const updatedList = allInvoicesList.map((item) => {
      const isMatch = isCombine ? item.school_id === key : item.id === key;

      if (isMatch) {
        const updatedItem = { ...item, checked: !item.checked };

        if (updatedItem.checked) {
          AddSelectedChallan(updatedItem);
        } else {
          RemoveSelectedChallan(updatedItem);
        }

        return updatedItem;
      }

      return item;
    });

    setAllInvoicesList(updatedList);
  };

  const AddSelectedChallan = (item) => {
    setSelectedChallans((prev) => {
      const exists = prev.some((p) =>
        isCombine ? p.school_id === item.school_id : p.id === item.id,
      );

      if (exists) return prev;

      return [...prev, item];
    });
  };

  const RemoveSelectedChallan = (item) => {
    setSelectedChallans((prev) =>
      prev.filter((p) =>
        isCombine ? p.school_id !== item.school_id : p.id !== item.id,
      ),
    );
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-3">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <select
              onChange={(e) => changesession(e.target.value)}
              className="form-select"
              style={{ height: 40 }}
              value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Region</b>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="regionId"
              value={regionId}
              onChange={(e) => setRegionId(e.target.value)}
              aria-label="Default select example"
            >
              <option value=""> Select Region</option>
              {regionsData.map((region, index) => (
                <option key={index} value={region.id}>
                  {region.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select School Account</b>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="schoolAccountId"
              value={schoolAccountId}
              onChange={(e) => setSchoolAccountId(e.target.value)}
              aria-label="Default select example"
            >
              <option value=""> Select School Account</option>
              {schoolAccountData.map((school, index) => (
                <option key={index} value={school.id}>
                  {school.school_name}
                </option>
              ))}
            </select>
          </div>

          <div className=" d-flex col-md-4 mt-7">
            <button
              type={"submit"}
              onClick={getInvoices}
              className="btn btn-primary mr-4"
            >
              Get Invoices
            </button>

            {showResult && allInvoicesList.length > 0 ? (
              <>
                {/* <ReactToPrint
                  pageStyle={pageStyle}
                  documentTitle="Payment Invoice"
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary"
                    >
                      {printloading ? "Printing..." : "Print Invoice"}
                    </button>
                  )}
                  content={() => componentRef.current}
                /> */}

                <div className="mt-4">
                  <label className="checkbox checkbox-single">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      checked={isCombine}
                      onChange={(e) => setIsCombine(e.target.checked)}
                    />
                    <span />
                    &nbsp;&nbsp;&nbsp;Combine Invoice
                  </label>
                </div>
              </>
            ) : null}
          </div>
          {/* {showResult && allInvoicesList.length > 0 ? (
            <div className=" d-flex col-md-3 mt-7">
              <button
                className="btn btn-primary"
                onClick={() => downloadInvoicesPdf(selectedChallans)}
              >
                Download All
              </button>
            </div>
          ) : null} */}
        </div>

        <div
          className="table-responsive"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <Table
            className="mt-5"
            style={{ width: `${isCombine}` ? "100%" : "120%" }}
          >
            <thead>
              <tr id="tbl">
                <th style={{ width: "5px" }}>
                  <label className="checkbox checkbox-single">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      onClick={(e) => {
                        handleMainCheckboxClick();
                      }}
                      checked={mainCheckBoxChecked}
                    />
                    <span />
                  </label>
                </th>
                <th className="text-center">
                  {isCombine ? "Total Inoice" : null}
                </th>
                {isCombine ? null : (
                  <th className="text-center">Invoice No.</th>
                )}
                <th className="text-center">School Account</th>
                <th className="text-center">Region Name</th>
                {isCombine ? null : <th className="text-center">Month</th>}
                <th className="text-center">Collected Amount</th>
                <th className="text-center">Pending Amount</th>
                {isCombine ? null : <th className="text-center">Status</th>}
                {isCombine ? null : <th className="text-center">Due Date</th>}
                {isCombine ? null : <th className="text-center">Issue Date</th>}
              </tr>
            </thead>
            <tbody>
              {allInvoicesList &&
                allInvoicesList.map((invoice) => (
                  <tr
                    className="text-center"
                    style={{
                      color: `${isCombine}`
                        ? "black"
                        : statusColorMap[invoice?.payment_status],
                    }}
                  >
                    <td style={{ width: "5px" }}>
                      <label className="checkbox checkbox-single">
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          value={isCombine ? invoice.school_id : invoice.id}
                          onChange={(e) =>
                            handleChallansCheckBoxClick(
                              isCombine ? invoice.school_id : invoice.id,
                            )
                          }
                          checked={invoice.checked ?? false}
                        />
                        <span />
                      </label>
                    </td>
                    <td>{isCombine ? invoice?.total_invoices : null}</td>
                    {isCombine ? null : <td>{invoice?.invoice_number}</td>}
                    <td>
                      {isCombine
                        ? invoice?.school_name
                        : invoice?.school_account?.school_name ??
                          invoice?.school_account_id}
                    </td>
                    <td>
                      {isCombine
                        ? invoice?.region_name
                        : invoice?.school_account?.region?.name ??
                          invoice?.school_account_id}
                    </td>
                    {isCombine ? null : <td>{getMonthName(invoice?.month)}</td>}
                    <td>
                      {Intl.NumberFormat("en-Us").format(
                        isCombine ? invoice?.total_paid : invoice?.paid,
                      )}
                    </td>
                    <td>
                      {Intl.NumberFormat("en-Us").format(
                        isCombine ? invoice?.total_balance : invoice?.balance,
                      )}
                    </td>
                    {isCombine ? null : (
                      <td>
                        <span
                          style={{
                            backgroundColor:
                              statusColorMap[invoice?.payment_status] ||
                              "black",
                            color: "white",
                            padding: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          {statusMap[invoice?.payment_status]}
                        </span>
                      </td>
                    )}
                    {isCombine ? null : <td>{invoice?.due_date}</td>}
                    {isCombine ? null : <td>{invoice?.issue_date}</td>}
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : null}

        {/* Print Invoice */}
        {/* <div
          ref={componentRef}
          id="printSection"
          style={{ visibility: "hidden" }}
        >
          <PrintSchoolInvoice
            allInvoicesList={
              allInvoicesList.length == selectedChallans.length
                ? allInvoicesList
                : selectedChallans
            }
            isCombine={isCombine}
          />
        </div> */}
      </Paper>
    </div>
  );
};

export default InvoicesDuePayment;
